<app-window-title
  title="Edit Facility Owner"
  [closable]="true"
  (closed)="onCancel()">
</app-window-title>

<div mat-dialog-content style="padding: 24px 24px 8px">

  <div class="facility-banner">
    <mat-icon class="facility-banner__icon">business</mat-icon>
    <span class="facility-banner__name">{{ data.facility.name }}</span>
  </div>

  <form [formGroup]="form" class="fx-col" style="margin-top: 20px; gap: 4px">
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Full Name</mat-label>
      <mat-icon matPrefix style="margin-right: 8px">person</mat-icon>
      <input matInput formControlName="name" autocomplete="off" />
      <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Email Address</mat-label>
      <mat-icon matPrefix style="margin-right: 8px">email</mat-icon>
      <input matInput type="email" formControlName="email" autocomplete="off" />
      <mat-error *ngIf="form.get('email')?.hasError('required')">Email is required</mat-error>
      <mat-error *ngIf="form.get('email')?.hasError('email')">Please enter a valid email address</mat-error>
      <mat-hint>Email cannot be changed after account creation.</mat-hint>
    </mat-form-field>
  </form>

  <div class="invite-hint">
    <mat-icon class="invite-hint__icon">info_outline</mat-icon>
    <span>
      <strong>Save &amp; Invite</strong> sends an email from
      <em>{{ data.facility.name }}</em> inviting the recipient to join the NuageDx network
      and complete their facility registration.
    </span>
  </div>

</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button type="button" (click)="onCancel()" [disabled]="saving">
    Cancel
  </button>
  <button
    mat-stroked-button
    type="button"
    (click)="onSave()"
    [disabled]="saving || form.invalid">
    <span *ngIf="saving" class="spinner-wrap">
      <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
    </span>
    Save
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="onSaveAndInvite()"
    [disabled]="saving || form.invalid">
    <span *ngIf="saving" class="spinner-wrap">
      <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
    </span>
    <mat-icon *ngIf="!saving" style="font-size: 18px; width: 18px; height: 18px; margin-right: 4px">send</mat-icon>
    Save &amp; Invite
  </button>
</div>
